var map = {
	"./7-11.png": [
		5243,
		243
	],
	"./A&W (Canada).png": [
		9126,
		126
	],
	"./Bento Sushi.png": [
		5311,
		311
	],
	"./Boston Pizza.png": [
		8620,
		620
	],
	"./Browns Socialhouse.png": [
		6137,
		137
	],
	"./Burger King.png": [
		893,
		893
	],
	"./Cinnabon.png": [
		6963,
		963
	],
	"./Cinnzeo.png": [
		3519,
		519
	],
	"./Cora.png": [
		3764,
		764
	],
	"./Costco Food Court.png": [
		4559,
		559
	],
	"./Dairy Queen.png": [
		9654,
		654
	],
	"./De Dutch Pannekoek House.png": [
		7062,
		62
	],
	"./Domino's.png": [
		4795,
		795
	],
	"./Earls.png": [
		7478,
		478
	],
	"./Edo Japan.png": [
		9087,
		87
	],
	"./Fatburger.png": [
		4667,
		667
	],
	"./Freshii.png": [
		1867,
		867
	],
	"./KFC.png": [
		8443,
		443
	],
	"./Lee's Famous Recipe Chicken.png": [
		4875,
		875
	],
	"./Little Caesars Pizza.png": [
		127,
		127
	],
	"./Manchu Wok.png": [
		3914,
		914
	],
	"./McDonald's Canada.png": [
		2177,
		177
	],
	"./Mucho Burrito.png": [
		6664,
		664
	],
	"./New York Fries.png": [
		8387,
		387
	],
	"./Orange Julius.png": [
		9709,
		709
	],
	"./Panago Pizza.png": [
		123,
		123
	],
	"./Papa John’s.png": [
		9038,
		38
	],
	"./Pizza Hut.png": [
		4568,
		568
	],
	"./Popeyes.png": [
		1594,
		594
	],
	"./Red Robin.png": [
		3528,
		528
	],
	"./Starbucks.png": [
		121,
		121
	],
	"./Subway.png": [
		6322,
		322
	],
	"./Swiss Chalet.png": [
		3407,
		407
	],
	"./Thai Express.png": [
		2863,
		863
	],
	"./The Keg.png": [
		5855,
		855
	],
	"./The Old Spaghetti Factory.png": [
		1084,
		84
	],
	"./Tim Horton's.png": [
		6011,
		11
	],
	"./White Spot Restaurants.png": [
		1860,
		860
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7186;
module.exports = webpackAsyncContext;